import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTextArea from "components/CustomTextArea";
import CustomInput from "components/CustomInput/CustomInput";
import FixedResponseInput from "components/CustomInput/FixedResponseInput";
import React from "react";

export default ({ formik, index }) => {
  const deleteQuestion = () => {
    const qust = (formik.values.questions || []).splice(index, 1);
    formik.setFieldValue({ ...formik.values, qust });
  };
  
  const isRangeType = formik.values?.questions?.[index]?.type === "range";
  const isFixedType = formik.values?.questions?.[index]?.type === "fixed";
  
  return (
    <div
      key={index}
      className={(index > 0 && "mt-2") + " d-flex p-1 gap-2 flex-column"}
    >
      <CustomTextArea
        errorClass="errorMessage"
        textColor={"black"}
        textAreaClass="form-control border-radius questionTextArea"
        formik={formik}
        hasError={formik.errors?.questions?.[index]?.questions ? true : false}
        errorMessage={formik.errors?.questions?.[index]?.questions}
        placeholder="Write Here"
        fieldName={`questions[${index}].questions`}
        rows={1}
        defaultValue={formik.values?.questions?.[index]?.questions}
      />
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2">
          <div
            onClick={(e) => {
              formik.setFieldValue(`questions[${index}].type`, "range");
              // Set default values for range
              if (!formik.values?.questions?.[index]?.minValue) {
                formik.setFieldValue(`questions[${index}].minValue`, 1);
              }
              if (!formik.values?.questions?.[index]?.maxValue) {
                formik.setFieldValue(`questions[${index}].maxValue`, 10);
              }
            }}
            role="button"
          >
            <input
              type="radio"
              name={`questions.[${index}].type`}
              checked={isRangeType}
            />
            &nbsp; Range
          </div>
          <div
            role="button"
            onClick={(e) => {
              formik.setFieldValue(`questions[${index}].type`, "text");
            }}
          >
            <input
              name={`questions.[${index}].type`}
              type="radio"
              checked={formik.values?.questions?.[index]?.type === "text"}
            />
            &nbsp; Text
          </div>
          <div
            role="button"
            onClick={(e) => {
              formik.setFieldValue(`questions[${index}].type`, "fixed");
              // Initialize options array if not exists
              if (!formik.values?.questions?.[index]?.options) {
                formik.setFieldValue(`questions[${index}].options`, [
                  { id: Date.now() + Math.random(), option: "" },
                  { id: Date.now() + Math.random() + 1, option: "" }
                ]);
              }
            }}
          >
            <input
              name={`questions.[${index}].type`}
              type="radio"
              checked={isFixedType}
            />
            &nbsp; Fixed
          </div>
        </div>
        <FontAwesomeIcon
          onClick={() => deleteQuestion()}
          style={{
            cursor: "pointer",
          }}
          icon={faTrashAlt}
          id="togglePassword"
        />
      </div>
      
      {isRangeType && (
        <div className="d-flex gap-2 mt-2">
          <div className="flex-fill">
            <label style={{ fontSize: "0.85rem", fontWeight: "500" }}>
              Min Value
            </label>
            <CustomInput
              inputProps={{
                type: "number",
                placeholder: "Min",
                value: formik.values?.questions?.[index]?.minValue || "",
                name: `questions[${index}].minValue`,
                error:
                  !!formik.errors?.questions?.[index]?.minValue &&
                  !!formik.touched?.questions?.[index]?.minValue
                    ? formik.errors?.questions?.[index]?.minValue
                    : null,
              }}
              inputClass="form-control"
              onChange={(e) => {
                formik.setFieldValue(
                  `questions[${index}].minValue`,
                  Number(e.target.value)
                );
              }}
            />
          </div>
          <div className="flex-fill">
            <label style={{ fontSize: "0.85rem", fontWeight: "500" }}>
              Max Value
            </label>
            <CustomInput
              inputProps={{
                type: "number",
                placeholder: "Max",
                value: formik.values?.questions?.[index]?.maxValue || "",
                name: `questions[${index}].maxValue`,
                error:
                  !!formik.errors?.questions?.[index]?.maxValue &&
                  !!formik.touched?.questions?.[index]?.maxValue
                    ? formik.errors?.questions?.[index]?.maxValue
                    : null,
              }}
              inputClass="form-control"
              onChange={(e) => {
                formik.setFieldValue(
                  `questions[${index}].maxValue`,
                  Number(e.target.value)
                );
              }}
            />
          </div>
        </div>
      )}
      
      {isFixedType && (
        <div className="mt-2">
          <FixedResponseInput 
            formik={formik} 
            fieldName={`questions.${index}.options`}
          />
        </div>
      )}
    </div>
  );
};
